import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';
import { v4 as uuid } from 'uuid';

const IconRow = ({
  icon: IconIcon,
  tx,
}: {
  readonly icon: SVGIconComponent;
  readonly tx: MessageKey;
}) => {
  const [id] = uuid().split('-');
  const t = useTranslations();
  const TABLE_CELL_CLASS = 'h-24 px-8 py-2 border';

  return (
    <tr>
      <td className={cx(TABLE_CELL_CLASS, 'flex items-center justify-center')}>
        <IconIcon aria-labelledby={id} />
      </td>
      <td id={id} className={cx(TABLE_CELL_CLASS, 'w-full')}>
        {t(tx)}
      </td>
    </tr>
  );
};

export default IconRow;
